module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-base-50.82356c3e.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-base-50.png
// module id = 2563
// module chunks = 11